export type Range = {
  start: string;
  end: string;
};

type BackForward = {
  back: number;
  forward: number;
};

export type ThumbRangeDaysWidth = {
  [key in Direction]: BackForward;
};

export enum Direction {
  Left = "LEFT",
  Right = "RIGHT"
}
